module.exports = __webpack_public_path__ + "static/PaulDraws_Bernard-e76074a839314730ba666ba3310937fa.jpg";